import { Playground } from 'docz';
import { times } from 'lodash';
import { Button, Inline, Grid, Box, Types, ThemeProps, HeaderText } from 'react-nails';
import React from 'react';
export default {
  Playground,
  times,
  Button,
  Inline,
  Grid,
  Box,
  Types,
  ThemeProps,
  HeaderText,
  React
};